import React from 'react'
import '../../Styles/Products.scss'
import pro1 from '../../Assests/Products/pro_logo1.jpg'
import pro2 from '../../Assests/Products/pro_logo2.jpg'
import pro3 from '../../Assests/Products/pro_logo3.jpg'
import pro4 from '../../Assests/Products/pro_logo4.jpg'
import pro5 from '../../Assests/Products/pro_logo5.jpg'
import pro6 from '../../Assests/Products/pro_logo6.jpg'

const Products = () => {
    const data = [
        {
          id: 1,
          image: pro1,
          text: 'Carrier Screening Test'
        },
        {
          id: 2,
          image: pro2,
          text: 'Comprehensive Genomic Test'
        },
        {
          id: 3,
          image: pro3,
          text: 'Gut Health Test Stool Collection Kit'
        },
        {
          id: 4,
          image: pro4,
          text: 'Longevity Package'
        },
        {
          id: 5,
          image: pro5,
          text: 'Newborn Screening Test'
        },
        {
          id: 6,
          image: pro6,
          text: 'Oral Health Test'
        }
      ];
      
    return (
        <div className='mt-5 pt-4 Products px-4'>
            <div className='fw-bold team-discover-story-text ' style={{ color: "#2D143D" }}>
                <div>Products</div>

            </div>

            <div className="row w-100 m-auto">
  {data.map((item) => (
    <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4 ">
        <div className='outerbox-size my-3 '>
            <div className='text-center'>
            <img src={item.image} alt={`Image ${item.id}`} className="img-fluid-products" />
                </div>
       
        <div className='images-inter-text my-3'>{item.text}</div>
        </div>
     
    </div>
  ))}
</div>

        </div>
    )
}

export default Products
